import { createSlice } from '@reduxjs/toolkit'
import { getUniqArray } from '../../helpers/common'

const initialState = {
  savedCards: [],
  selectedCard: null,
  isAddCard: false,
}

const cardsSlice = createSlice({
  name: 'cards',
  initialState,
  reducers: {
    cardsUpdate: (state, { payload }) => {
      state.savedCards = getUniqArray([...state.savedCards, ...payload])
    },
    cardsDelete: (state, { payload }) => {
      state.savedCards = state.savedCards.filter(
        card => !payload.includes(card.id),
      )
    },
    cardsUpdateAfterDeletion: (state, { payload }) => {
      state.savedCards = payload
    },
    cardSelect: (state, { payload }) => {
      state.selectedCard =
        state.savedCards.find(card => card.id === payload) || null
    },
    setAddCard: (state, { payload }) => {
      state.isAddCard = payload
    },
    clearSelection: state => {
      state.selectedCard = null
    },
    // Saved cards belong to one authenticated transaction. When the token
    // changes the MFE is reused for a new transaction, so the whole slice has
    // to go back to its initial state — `clearSelection` alone would leave the
    // previous user's cards in `savedCards`.
    cardsClear: () => initialState,
  },
})

export const {
  cardsUpdate,
  cardsDelete,
  cardsUpdateAfterDeletion,
  cardSelect,
  setAddCard,
  clearSelection,
  cardsClear,
} = cardsSlice.actions

export const cardsSelector = state => state.cards

export default cardsSlice.reducer
